/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.8.18",
    versionName: "0.2.0-nightly.2025.8.18",
    versionChannel: "nightly",
    buildDate: "2025-08-18T00:08:26.496Z",
    commitHash: "3a228552b9b68b733e81e26f42f7e9b54620d329",
};
